import {
  useGetSettingApiV1AdminSettingsGet,
  useUpdateSettingApiV1AdminSettingsPost,
} from "vl-api/vlComponents";
import { App } from "antd";
import { useQueryClient } from "@tanstack/react-query";

const SETTING_KEY = "FLYWHEEL_TRAIN_WORTHY_GOAL";

export const useTrainWorthy = () => {
  const { notification } = App.useApp();
  const queryClient = useQueryClient();

  const {
    data: settingData,
    isLoading: fetching,
    error: fetchError,
  } = useGetSettingApiV1AdminSettingsGet({
    queryParams: { key: SETTING_KEY },
  });

  const updateSettingMutation = useUpdateSettingApiV1AdminSettingsPost({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["getSettingApiV1AdminSettingsGet"],
      });

      notification.success({ message: "Threshold updated successfully." });
    },
    onError: (err: any) => {
      notification.error({
        message: "Failed to update threshold.",
        description: err.message || "An unknown error occurred",
      });
    },
  });

  const updateThreshold = (value: number) => {
    updateSettingMutation.mutate({
      body: { key: SETTING_KEY, value } as any,
    });
  };

  const getInitialValue = (): string | null => {
    if (settingData === null || settingData === undefined) return null;

    if (typeof settingData !== "object") {
      return String(settingData);
    }

    if (
      settingData[SETTING_KEY] !== undefined &&
      settingData[SETTING_KEY] !== null
    ) {
      return String(settingData[SETTING_KEY]);
    }

    if (
      (settingData as any).value !== undefined &&
      (settingData as any).value !== null
    ) {
      return String((settingData as any).value);
    }

    return "";
  };

  return {
    initialValue: getInitialValue(),
    fetching,
    isLoading: updateSettingMutation.isPending,
    error: fetchError ? "Failed to load settings" : null,
    updateThreshold,
  };
};

export default useTrainWorthy;
